/**
 * Datadog RUM - Main Export (Client-side only)
 *
 * NOTE: Do NOT import this in middleware.js - it uses env.js which doesn't work in Edge Runtime
 * For middleware, import directly from './datadogRumMiddleware.mjs'
 */

export { initDatadogRum, addRumContext, trackRumAction, trackRumError, setRumUser, clearRumUser } from './datadogRum'
export { extractDatadogRumFromHeaders } from './datadogRumHeaders'
